import { Component, ViewChild, ElementRef, ChangeDetectorRef, Input, Host, Inject, forwardRef, SimpleChanges } from "@angular/core";
import { BaseCheckboxComponent } from './baseCheckboxComponent';
import { CoCheckboxComponent } from "../coCheckboxComponent";
import { ImageSets } from "../../../utils";

@Component({
  selector: 'classic-checkbox',
  templateUrl: './classicCheckboxComponent.html'
})
export class ClassicCheckboxComponent extends BaseCheckboxComponent {

  @Input()
  public viewValue;

  public stateString: string;

  public imageSet: string;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['viewValue']) {
      this.stateString = this.getState();
    }
  }

  constructor(
    @Host() @Inject(forwardRef(() => CoCheckboxComponent)) public checkbox: CoCheckboxComponent,
    protected cdr: ChangeDetectorRef
  ) {
    super(checkbox, cdr);
  }

  ngOnInit() {
    this.imageSet = this.getImageSet(ImageSets.ControlLock);
    super.ngOnInit();
  }

  getState(): any {
    return this.checkbox.extractState(this.view.value);
  }

  @ViewChild('chekBoxButton')
  inputControlRef: ElementRef;

  
  readOnlyClick(): void {
    this.checkbox.notifyIfReadOnly(this.view, null);
  }

}